<template>
  <div>
    <div class="row payment-details">
      <div class="col-md-6">
        <div>
          <label>Total -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ grandTotal }}
          </span>
        </div>
        <div>
          <label>Paid -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ paidAmount }}
          </span>
        </div>
        <div>
          <label>Outstanding -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ outstanding }}
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div>
          <label>Labor Total -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ serviceRequest.vendorInvoice ? laborCostTotal : 0 }}
          </span>
        </div>
        <div>
          <label>Chalan Total -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ serviceRequest.saleId ? chalanTotal : 0 }}
          </span>
        </div>
        <div>
          <label>External Goods Total -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ serviceRequest.vendorInvoice ? externalGoodsTotal : 0 }}
          </span>
        </div>
        <div>
          <label>Internal Goods Total -</label>
          <span>
            <i class="fas fa-rupee-sign" />
            {{ serviceRequest.vendorInvoice ? internalGoodsTotal : 0 }}
          </span>
        </div>
      </div>
    </div>
    <!-- <hr > -->
    <div class="row">
      <el-button 
        type="primary" 
        @click="openTransactionDialog()"
      >Add New Transaction</el-button
      >
    </div>
    <div class="row transaction-list">
      <el-table :data="serviceRequestTransactions">
        <el-table-column 
          type="index" 
          label="#" />
        <el-table-column label="Date">
          <template slot-scope="scope">
            {{ scope.row.updatedAt | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column 
          label="Amount" 
          prop="amount" />
        <el-table-column label="Is Advance">
          <template slot-scope="scope">
            {{ scope.row.isAdvance | typeFormat }}
          </template>
        </el-table-column>
        <el-table-column label="Payment Mode">
          <template slot-scope="scope">
            <span v-if="scope.row.paymentMode">
              {{ scope.row.paymentMode.label }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog 
      :visible.sync="showTransactionForm" 
      title="Add Transaction">
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="serviceRequestTransaction.amount"
            label="Amount"
          />
        </div>
        <div class="col-md-6">
          <base-input label="Payment Mode">
            <el-select v-model="serviceRequestTransaction.paymentModeId">
              <el-option
                v-for="(item, index) in paymentModes"
                :key="index"
                :label="item.label"
                :value="item.paymentModeId"
              />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Is Advance Amount?">
            <el-radio
              v-model="serviceRequestTransaction.isAdvance"
              :label="true"
            >Yes</el-radio
            >
            <el-radio
              v-model="serviceRequestTransaction.isAdvance"
              :label="false"
            >No</el-radio
            >
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input
            v-uppercase
            v-model="serviceRequestTransaction.paymentNote"
            label="Payment Note"
          />
        </div>
      </div>
      <span 
        slot="footer" 
        class="dialog-footer">
        <el-button @click="showTransactionForm = false">Cancel</el-button>
        <el-button 
          type="primary" 
          @click="addTransaction()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Button,
  Dialog,
  Select,
  Option,
  Table,
  TableColumn,
  Radio,
} from "element-ui";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import dateFns from "date-fns";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Radio.name]: Radio,
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(new Date(value), "DD MMM YYYY");
    },
    typeFormat(value) {
      if (value === true) {
        return "Advance Amount";
      } else {
        return "--";
      }
    },
  },
  data() {
    return {
      showTransactionForm: false,
      chalanTotal: 0,
      outstanding: 0,
      paidAmount: 0,
      laborCostTotal: 0,
      externalGoodsTotal: 0,
      grandTotal: 0,
      internalGoodsTotal: 0,
    };
  },
  computed: {
    ...mapState("serviceRequestTransaction", ["serviceRequestTransaction"]),
    ...mapState("serviceRequest", ["serviceRequest"]),
    ...mapGetters({
      paymentModes: "paymentMode/getPaymentModes",
      serviceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions",
      serviceRequestLabors: "serviceRequestLabor/getServiceRequestLaborsList",
      statuses: "status/getStatusList",
    }),
  },
  mounted() {
    this.getPaymentModes();
    this.getServiceRequestTransactions(this.$route.params.id);
    this.fetchServiceRequestAccountDetails(this.$route.params.id);
    this.getStatusList();
  },
  methods: {
    ...mapActions({
      getPaymentModes: "paymentMode/getPaymentModes",
      saveServiceRequestTransaction:
        "serviceRequestTransaction/saveServiceRequestTransaction",
      getServiceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions",
      getServiceRequestAccountDetails:
        "serviceRequest/getServiceRequestAccountDetails",
      getStatusList: "status/getStatusList",
    }),
    ...mapMutations({
      resetServiceRequestTransaction:
        "serviceRequestTransaction/resetServiceRequestTransaction",
    }),
    openTransactionDialog() {
      if (this.serviceRequest.status.code != "completed") {
        this.showTransactionForm = true;
      } else {
        this.$notify({
          message: "Sorry, you cannot add transaction with completed status!",
          type: "danger",
          title: "Failure",
        });
      }
    },
    addTransaction() {
      this.saveServiceRequestTransaction({
        type: "no-advance",
        serviceRequestId: this.$route.params.id,
      }).then(() => {
        this.showTransactionForm = false;
        this.resetServiceRequestTransaction();
        this.getServiceRequestTransactions(this.$route.params.id);
        this.fetchServiceRequestAccountDetails(this.$route.params.id);
        this.$notify({
          message: "Transaction Added Successfully!",
          type: "success",
          title: "Success",
        });
      });
    },

    fetchServiceRequestAccountDetails(serviceRequestId) {
      this.getServiceRequestAccountDetails(serviceRequestId).then(
        async (res) => {
          this.chalanTotal = res.data.chalanTotal;
          this.paidAmount = res.data.paidAmount;
          this.laborCostTotal = res.data.serviceRequestLaborTotal;
          this.externalGoodsTotal = res.data.externalGoodsTotal;
          this.internalGoodsTotal = res.data.internalGoodsTotal;
          this.grandTotal = this.serviceRequest.vendorInvoice
            ? this.laborCostTotal + this.externalGoodsTotal
            : 0;
          this.grandTotal = this.serviceRequest.saleId
            ? this.grandTotal + this.chalanTotal
            : this.grandTotal + 0;
          this.outstanding = this.grandTotal - this.paidAmount;
        }
      );
    },
  },
};
</script>

<style>
.transaction-list {
  margin-top: 20px;
  margin-bottom: 90px;
}
.payment-details label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
  margin-right: 25px;
}
</style>


